import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import DownloadIcon from '@mui/icons-material/Download';
import Moment from 'moment';
import GridNoRow from '../../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import { useParams } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_QualityMeasurementDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const fromSearch = location.state?.fromSearch || {};
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [data, setData] = useState(null);
    const [fileRows, setFileRows] = useState([]);
    const [fileColumns, setFileColumns] = useState([]);

    useEffect(() => {
        // 권한 설정은 주석 처리된 상태
        if(params.quality_measurement_id === null || typeof params.quality_measurement_id === 'undefined'){
            navigate("/m/quality_measurement", { state: { fromSearch } });
        }

        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
        }, 800);
    }, []);
    
    useEffect(() => {
        setFileColumns([
            {
                field: 'download',
                headerName: '다운로드',
                width: 100,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
            { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
            { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
            { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
            { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
            { field: 'file_type_name', headerName: '유형', width: 120, headerAlign: 'center', align:'center' },
            { field: 'file_size_dp', headerName: '크기', width: 120, headerAlign: 'center', align:'right' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'reg_datetime', headerName: '등록일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
        
        if(String(MenuID) !== String(0) && typeof fromSearch.originRows === 'undefined'){
            handleSearch();
        }else{
            setOriginRows(fromSearch.originRows);
        }
    }, [MenuID]);

    useEffect(() => {
        if(typeof originRows !== 'undefined'){
            if(originRows.length > 0){
                setData(
                    {
                        quality_measurement_group_id: Number(originRows[0].quality_measurement_group_id),
                        quality_measurement_parent_id: Number(originRows[0].quality_measurement_parent_id),
                        quality_id: Number(originRows[0].quality_id),
                        quality_name: originRows[0].quality_name,
                        quality_item_id: typeof originRows[0].quality_item_id === 'undefined'?null:originRows[0].quality_item_id,
                        quality_item_name: originRows[0].quality_item_name,
                        quality_item_spec: appStore.ITEM_FULL_SPEC_MAKE(originRows[0].quality_item_spec, originRows[0].quality_item_width, originRows[0].quality_item_depth, originRows[0].quality_item_height),
                        quality_measurement_item_id: typeof originRows[0].quality_measurement_item_id === 'undefined'?null:originRows[0].quality_measurement_item_id,
                        quality_measurement_standard: originRows[0].quality_measurement_standard,
                        quality_measurement_status: originRows[0].quality_measurement_status,
                        quality_measurement_number: originRows[0].quality_measurement_number,
                        quality_measurement_lotno: originRows[0].quality_measurement_lotno,
                        quality_measurement_value: typeof originRows[0].quality_measurement_value === 'undefined'?"":originRows[0].quality_measurement_value,
                        quality_measurement_option_value: typeof originRows[0].quality_measurement_option === 'undefined'?"":originRows[0].quality_measurement_option,
                        quality_measurement_option_name_value: typeof originRows[0].quality_measurement_option_name === 'undefined'?"":originRows[0].quality_measurement_option_name,
                        quality_measurement_result: typeof originRows[0].quality_measurement_result === 'undefined'?"":originRows[0].quality_measurement_result,
                        quality_measurement_result_name: typeof originRows[0].quality_measurement_result_name === 'undefined'?"":originRows[0].quality_measurement_result_name,
                        quality_measurement_user_id: typeof originRows[0].quality_measurement_user_id === 'undefined'?null:originRows[0].quality_measurement_user_id,
                        quality_measurement_user_name: typeof originRows[0].quality_measurement_user_name === 'undefined'?"":originRows[0].quality_measurement_user_name,
                        quality_measurement_datetime: typeof originRows[0].quality_measurement_datetime === 'undefined'?"":Moment(originRows[0].quality_measurement_datetime).format('YYYY-MM-DD HH:mm:ss'),
                        quality_measurement_produce_work_id: typeof originRows[0].quality_measurement_produce_work_id === 'undefined'?null:originRows[0].quality_measurement_produce_work_id,
                        quality_measurement_produce_work_number:  typeof originRows[0].quality_measurement_produce_work_number === 'undefined'?"":originRows[0].quality_measurement_produce_work_number,
                        quality_measurement_incoming_id:  typeof originRows[0].quality_measurement_incoming_id === 'undefined'?null:originRows[0].quality_measurement_incoming_id,
                        quality_measurement_incoming_number:  typeof originRows[0].quality_measurement_incoming_number === 'undefined'?"":originRows[0].quality_measurement_incoming_number,
                        quality_measurement_outgoing_id:  typeof originRows[0].quality_measurement_outgoing_id === 'undefined'?null:originRows[0].quality_measurement_outgoing_id,
                        quality_measurement_outgoing_number:  typeof originRows[0].quality_measurement_outgoing_number === 'undefined'?"":originRows[0].quality_measurement_outgoing_number,
                        quality_measurement_bigo: originRows[0].quality_measurement_bigo
                    }
                )
                
                var fileData = originRows.filter((item, index) => {
                    return (
                    originRows.findIndex((item2, index2) => {
                        return typeof item.quality_measurement_file_id !== 'undefined' && item.quality_measurement_file_id === item2.quality_measurement_file_id;
                    }) === index
                    );
                });
            
                fileData = fileData.sort(function(a, b) { 
                    return a.quality_measurement_file_id < b.quality_measurement_file_id ? -1 : a.quality_measurement_file_id > b.quality_measurement_file_id ? 1 : 0;
                });
            
                setFileRows(fileData.map((item, index) => ({
                    id: item.quality_measurement_file_id,
                    file_name_sever: item.quality_measurement_file_name_sever,
                    file_size: item.quality_measurement_file_size,
                    file_type: item.quality_measurement_file_type,
                    file_extension: item.quality_measurement_file_extension,
                    file_name: item.quality_measurement_file_name,
                    file_type_name: item.quality_measurement_file_type_name,
                    file_size_dp: item.quality_measurement_file_size_dp,
                    reg_user_name: item.quality_measurement_file_user_name,
                    reg_datetime: Moment(item.quality_measurement_file_user_datetime).format('YYYY-MM-DD HH:mm:ss')
                })));
            }
        }
    }, [originRows]);

    const handleSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/QualityMeasurement/List',
            {
                params: {
                    quality_measurement_id: params.quality_measurement_id
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            setOriginRows(response.data);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            setTimeout(() => appStore.setLoading(false), 300);
        });
    };

    const fileDownloadClick = (object) => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
                    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

        if (isIOS) {
            // iOS는 XHR+blob 대신, 폼 POST로 새 탭 열어 서버가 직접 다운로드 처리
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/api/SaveCommon/FileDownload';
            form.target = '_blank'; // 새 탭 (팝업 차단 회피용: 클릭 안에서 즉시 submit)

            const add = (n, v) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = n;
                input.value = v ?? '';
                form.appendChild(input);
            };
            add('fileName', object.row.file_name);
            add('fileNameSever', object.row.file_name_sever);
            document.body.appendChild(form);
            form.submit();
            form.remove();
            return;
        }

        // 나머지(PC/안드): 기존 axios + blob
        axios.post(
            '/api/SaveCommon/FileDownload',
            new URLSearchParams({
                fileName: object.row.file_name,
                fileNameSever: object.row.file_name_sever
            }),
            { withCredentials: true, responseType: 'blob' }
        ).then((res) => {
            if (res.status !== 200) return appStore.capture();
            const type = res.headers?.['content-type'] || 'application/octet-stream';
            const blob = new Blob([res.data], { type });
            const url  = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = object.row.file_name || 'download.bin';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        }).catch((e) => {
            appStore.capture();
            console.log('다운로드 실패', e);
        });
    };

    const handleList = () => {
        navigate("/m/quality_measurement", { state: { fromSearch } });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' }}>
            <div className="M_menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={{ float: 'right' }}>
                        <Button
                            onClick={handleList}
                            className="M_btn-p"
                            sx={{
                                m: 1,
                                fontSize: 15,
                                color: "white", 
                                borderColor: "black", 
                                backgroundColor: "black",
                                ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                            }}
                            variant="outlined">
                            목록
                        </Button>
                    </div>
                </div>
            </div>

            <div className="M_contents">
                <div style={{ overflow: 'hidden' }}>
                    {/* 품질측정 기본 정보 */}
                    {data ? (
                        <>
                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>품질측정 정보</h2>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>품질측정번호</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.quality_measurement_number || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>품질측정 LotNo</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.quality_measurement_lotno || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>품질정보</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.quality_name || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>품질품목정보</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.quality_item_name || '-'} {data.quality_item_spec || '-'}</div>
                            </div>
                            
                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>품질측정</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>
                            {
                                [
                                data.quality_measurement_result_name,
                                (data.quality_measurement_option_name_value && data.quality_measurement_option_name_value.trim() !== '')
                                    ? data.quality_measurement_option_name_value
                                    : (data.quality_measurement_value && data.quality_measurement_value.toString().trim() !== ''
                                        ? data.quality_measurement_value
                                        : '-')
                                ]
                                .filter((v) => v && v.toString().trim() !== '')
                                .join(' / ') || '-'
                            }
                            </div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>품질측정일시</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>
                                {
                                [data.quality_measurement_user_name, data.quality_measurement_datetime]
                                    .filter((v) => v && v.trim() !== '')
                                    .join(' / ') || '-'
                                }
                            </div>
                            </div>
                            
                            
                            <div style={{ padding: '8px 0' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>비고</div>
                            <div 
                                style={{ 
                                fontSize: '16px', 
                                color: '#333', 
                                marginTop: '4px',
                                whiteSpace: 'pre-wrap', // 줄바꿈 유지
                                lineHeight: '1.5'       // 가독성 좋게 줄 간격 추가
                                }}
                            >
                                {(data.quality_measurement_bigo && data.quality_measurement_bigo.trim() !== '') 
                                ? data.quality_measurement_bigo 
                                : '-'}
                            </div>
                            </div>
                        </div>
                        
                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>품질측정 파일</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={fileRows}
                                    columns={fileColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, file_name_sever: false, file_size: false, file_type : false, file_extension: false, download: false}}
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        </>
                    ) : (
                        <p style={{ textAlign: "center", color: "#999" }}>품질측정 데이터를 불러오는 중입니다...</p>
                    )}
                    </div>

            </div>
        </div>
    );
};

export default MOB_QualityMeasurementDetail;